// extracted by mini-css-extract-plugin
module.exports = {"labelChecked":"RadioInputForm_labelChecked__1OrMc"};